import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @author Santiago Hernández
 * @updated 26-06-2025
 * @version jdesk_1.01.0009.4
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomIntegracionSodimac extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm                                   = this.initForm.bind(this);
        this.validarArchivo                             = this.validarArchivo.bind(this);
        this.url_servidor                               ='';
        this.estadoUF                                   ='';
        this.nombre_archivo                             ='';
        this.datos_file                                 ='';
        this.idRegistro                                 = 0;
        this.traerUrlSubirArchivos                      = this.traerUrlSubirArchivos.bind(this);
        this.succesTraerUrlSubirArchivos                = this.succesTraerUrlSubirArchivos.bind(this);
        this.archivo_subido                             = false;
        this.successData                                = this.successData.bind(this);
        this.gridOptionsComponentesO6                   = Object.assign({},this.gridOptions);
        this.gridOptionsComponentesO7                   = Object.assign({},this.gridOptions);
        this.setButtonBuscarNit                         = this.setButtonBuscarNit.bind(this);
        this.asignarNit                                 = this.asignarNit.bind(this);
        this.DatosModalNit                              = this.DatosModalNit.bind(this);
        this.setButtonIntegrar                          = this.setButtonIntegrar.bind(this);
        this.integrarPedido                             = this.integrarPedido.bind(this);
        this.setButtonItems                             = this.setButtonItems.bind(this);
        this.traerItems                                 = this.traerItems.bind(this);
        this.succesTraerItems                           = this.succesTraerItems.bind(this);
        this.gridOptionsComponentesItems                = Object.assign({},this.gridOptions);
        this.successIntegrarPedido                      = this.successIntegrarPedido.bind(this);
        this.abrirTbPrincipal                           = this.abrirTbPrincipal.bind(this);
    }


    initForm(){
        console.log('Formulario CustomIntegracionSodimac,  @version: jdesk_1.01.0009.4, @author:Santiago Hernández.');      
        this.getField('archivo').setOnChange((props) => { 
            this.estadoUF = 'xlsx'; 
            this.datos_file=props.target.files[0];
            this.validarArchivo(this.datos_file);

        });
        this.traerUrlSubirArchivos();
        this.getField("btn_asignar_nit").setClick(this.asignarNit);
    } 

    traerUrlSubirArchivos(){
        let datos={ 
            datos: {}
        };
        this.generalFormatPmv = { tipo_servicio: 'inte-sodimac', operacion: 'obtenerurl', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.succesTraerUrlSubirArchivos,
                error: this.error_,
                general: this.generalFormatPmv
        });
      }
    
      succesTraerUrlSubirArchivos(data){
          if (data.estado_p === 200 )
          {
            this.url_servidor=data.data[0].url_subir_archivo;
          }else {
            this.url_servidor='';
          }
      }

    
    validarArchivo(e) {
        this.getField('objeto6').toggle(false);
        this.gridOptionsComponentesO6['rowData'] = [];
        this.getField('objetoItems').toggle(false);
        this.gridOptionsComponentesItems['rowData'] = [];

        if(this.url_servidor!=='' && this.url_servidor!==''){
            if(e !== undefined && e !==''){
                let url = this.url_servidor+'/integraciones/api/protected';
                if (this.estadoUF === 'xlsx') {
                    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, está validando el archivo... `);
                    this.getField("confirmModalCustom").setVisibleCancel(true);
                    this.getField("confirmModalCustom").setButtonConfirm(".");
                    this.getField('confirmModalCustom').toggle(true);
                }

                let file = e;
                this.nombre_archivo = file.name;

                //Validación de espacios en el nombre
                if (this.nombre_archivo.includes(" ")) {
                    this.getField('confirmModalCustom').toggle(false);
                    this.alertGeneral.toggle(true, 'El nombre del archivo no debe contener espacios. Por favor renómbralo antes de subirlo.', 'error');
                    return; // detener ejecución
                }

                const data = {
                    _generales: { "tipo_servicio": "inte-sodimac", "operacion": "subirarchivos"},
                    archivo: file,
                };

                this.generalFormat = data._generales;
                this.service.send(
                    {
                        endpoint: url,
                        method: 'POST',
                        body: data,
                        success: this.successData,
                        error: this.error_,
                        general: this.generalFormat,
                        formData: true,
                        showMessage: false
                    });
            }
        }else{
            this.alertGeneral.toggle(true, 'Url del servidor mal configurada.', 'error'); 
        }
    }

    successData(data) {
        this.getField('confirmModalCustom').toggle(false);
        let createElement = this.createElementJaivana;
        if (data.estado_p === 200) {
            this.arrayTbPrincipal = data.data;
            this.gridOptionsComponentesO6['rowData'] = [];
            this.getField('objeto6').toggle(false);
            
            this.alertGeneral.toggle(true, 'Archivo integrado con éxito.', "success");
            this.archivo_subido=true;

            this.archivo_subido=false;
            this.getField('objeto7').toggle(true);
            let configCell = new Map();
            configCell.set('cliente', { cellRenderer: this.setButtonBuscarNit, width: 110, sortable: false, filter: false, field: 'cliente' });
            configCell.set('estado_integracion', { cellRenderer: function (props) { 
                if (props.data.estado_integracion === 'INTEGRADO') {
                    let div = document.createElement("input");
                    div.setAttribute("id", `div_${props.data.id}`);
                    div.setAttribute("value",props.data.estado_integracion);
                    div.setAttribute("class","divStyle3");
                    div.setAttribute("type","div");
                    div.setAttribute("disabled", true);
                    return createElement(div);
                }else if(props.data.estado_integracion === 'NO INTEGRADO'){
                    let div = document.createElement("input");
                    div.setAttribute("id", `div_${props.data.id}`);
                    div.setAttribute("value",props.data.estado_integracion);
                    div.setAttribute("class","divStyle4");
                    div.setAttribute("type","div");
                    div.setAttribute("disabled", true);
                    return createElement(div);
                }else{
                    return props.data.estado_integracion
                }
            }, field: 'estado_integracion' });
            configCell.set('integrar', { cellRenderer: this.setButtonIntegrar, width: 110, sortable: false, filter: false, field: 'integrar' });
            configCell.set('items', { cellRenderer: this.setButtonItems, width: 110, sortable: false, filter: false, field: 'items' });
            this.gridOptionsComponentesO7['rowData'] = this.arrayTbPrincipal;
            this.getField('objeto7').initData(this.gridOptionsComponentesO7, configCell);

        }else {
            this.gridOptionsComponentesO7['rowData'] = [];
            this.getField('objeto7').toggle(false);

            this.archivo_subido=false;
            this.getField('objeto6').toggle(true);
            let configCell = new Map();
            this.gridOptionsComponentesO6['rowData'] = data.data.errores;
            this.getField('objeto6').initData(this.gridOptionsComponentesO6, configCell);
        }
    }

    setButtonBuscarNit(props) {
        let button = document.createElement("input");
        let id = props.data.numero_orden;

        button.onclick = () => {
            this.getField('modal_buscar_nit').handleClickOpen();
            this.DatosModalNit(id);
        };

        button.setAttribute("id", "button_search_nit_");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Cliente");

        // Condición única: deshabilitar si está INTEGRADO o si NIT tiene datos
        if ( props.data.estado_integracion === "INTEGRADO" || (props.data.nit && props.data.nit.trim() !== "")) {
            button.setAttribute("disabled", true);
            button.setAttribute("class", "buttonDisabled");
        } else {
            button.removeAttribute("disabled");
            button.setAttribute("class", "buttonStyle");
        }

        return this.createElementJaivana(button);
    }

    DatosModalNit(id){
        this.idRegistro = id;
    }

    asignarNit(){
        if(this.getField("sede_nit").valid()){
            let dataNuevo = {};
            let arrayNuevo = [];

            this.arrayTbPrincipal.forEach((item) => {
                if (item.numero_orden===this.idRegistro){
                    let dataNuevo2 = item;
                    dataNuevo2['nit'] = this.getField("nitsx_sede").getValue()+"-"+this.getField("sede_nit").getValue();
                    dataNuevo2['nombre'] = this.getField("nombre_nit").getValue();
                    arrayNuevo.push(dataNuevo2);
                }else{
                    arrayNuevo.push(item);
                }
            });

            dataNuevo['data'] = arrayNuevo;
            dataNuevo['estado_p'] = 200;
            this.getField("modal_buscar_nit").handleClose();
            this.successData(dataNuevo);
        }
    }

    setButtonIntegrar(props){
        let id = props.data.numero_orden;
        let button = document.createElement("input");
        button.setAttribute("class", "buttonStyle");

        if(props.data.estado_integracion==="INTEGRADO"){
            button.setAttribute('disabled',true);
            button.setAttribute('class','buttonDisabled');
        }else{
            button.onclick = ()=>{this.integrarPedido(props.data);};
        }
        
        button.setAttribute("id", 'button_integrar_' + id);
        button.setAttribute("type", "button");
        button.setAttribute("value", "Integrar");
        return this.createElementJaivana(button);
    }

    integrarPedido(data){
        if(data.nit !== undefined && data.nit !== null){
            this.idRegistro = data.numero_orden;
            let datos = {
                datos:{
                    nit:data.nit.split("-")[0],
                    sede:parseInt(data.nit.split("-")[1]),
                    codigo_sucursal:JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal,
                    numero_orden:data.numero_orden,
                    origen:'sodimac'
                }
            };
            this.generalFormatPmv = { tipo_servicio: 'inte-sodimac', operacion: 'integrarpedido', operacion_tipo: 'crear' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'POST',
                    body: datos,
                    success: this.successIntegrarPedido,
                    error: this.error_,
                    general: this.generalFormatPmv
            });
        

        }else{
            this.alertGeneral.toggle(true, 'Error: Falta digitar el nit desde la columna cliente.', 'error');
        }
    }

    successIntegrarPedido(data){
        if(data.estado_p === 200){
            //this.getField('tabla_pedidos').toggle(false);
            this.getField('confirmModalCustom').setTitleAndContent('PEDIDO SODIMAC INTEGRADO', 'El pedido fue integrado exitosamente con número: '+data.data.numero_pedido+'.');
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setVisibleConfirm(false);
            this.getField("confirmModalCustom").setClickDialog(()=>{
                this.getField('confirmModalCustom').toggle(false);
                //this.getField('tabla_pedidos').toggle(false);
                this.abrirTbPrincipal(this.arrayTbPrincipal);
            });
            this.getField("confirmModalCustom").setButtonConfirm('Confirmar');
            this.getField('confirmModalCustom').toggle(true);


        }else if (data.estado_p === 502){
            this.getField('confirmModalCustom').setTitleAndContent('NO SE PUDO REALIZAR LA INTEGRACIÓN', 'Verificar por favor el pedido, los productos y el tercero.');
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setVisibleConfirm(false);
            this.getField("confirmModalCustom").setClickDialog(()=>{
                this.getField('confirmModalCustom').toggle(false);                
            });
            this.getField("confirmModalCustom").setButtonConfirm('Ok');
            this.getField('confirmModalCustom').toggle(true);

        }else{
            this.alertGeneral.toggle(true,data.data.errores.mensaje, 'error');
        }
    }

    
    setButtonItems(props){
        let id = props.data.numero_orden;
        let button = document.createElement("input");
        button.setAttribute("class", "buttonStyle");

        if(props.data.estado_integracion==="INTEGRADO"){
            button.setAttribute('disabled',true);
            button.setAttribute('class','buttonDisabled');
        }else{
            button.onclick = ()=>{this.traerItems(props.data);};
        }
        
        button.setAttribute("id", 'button_integrar_' + id);
        button.setAttribute("type", "button");
        button.setAttribute("value", "Items");
        return this.createElementJaivana(button);
    }

    traerItems(data){
        let datos={ 
            datos: {
                "numero_orden":data.numero_orden,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inte-sodimac', operacion: 'traeritems', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.succesTraerItems,
                error: this.error_,
                general: this.generalFormatPmv
        });
    }

    succesTraerItems(data){
        if (data.estado_p === 200) {
            this.getField('objetoItems').toggle(true);
            let configCell = new Map();
            configCell.set('precio_neto', {cellRenderer:function(props){return''.formatoPrecio(props.data.precio_neto.toFixed(2))},type: 'rightAligned',field:'precio_neto'});
            this.gridOptionsComponentesItems['rowData'] = data.data;
            this.getField('objetoItems').initData(this.gridOptionsComponentesItems,configCell);
        }else {
            this.alertGeneral.toggle(true, 'Error al retornar los items del pedido.', 'error');
        }
    }

    abrirTbPrincipal(){
        let dataNuevo = {};
        let arrayNuevo = [];
        this.arrayTbPrincipal.forEach((item) => {
            if (item.numero_orden===this.idRegistro){
                let dataNuevo2 = item;
                dataNuevo2['nit'] = item.nit;
                dataNuevo2['nombre'] = item.nombre;
                dataNuevo2['estado_integracion'] = "INTEGRADO";
                arrayNuevo.push(dataNuevo2);
            }else{
                arrayNuevo.push(item);
            }            
        });

        dataNuevo['data'] = arrayNuevo;
        dataNuevo['estado_p'] = 200;
        this.getField("modal_buscar_nit").handleClose();
        this.successData(dataNuevo);
    }




}
FormJaivana.addController("inte-sodimac",CustomIntegracionSodimac);
export default CustomIntegracionSodimac